/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
// import { useOnClickOutside } from "../../../../../CommonMethods/OutsideClick";
// import { useGetUsersQuery } from "../../features/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
export default function FilterDropdown({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    index,
    options,
    data_testid,
    handleReadingTypeSelect,
    deviceTemplateDetails,
    handleSelectAll,
    handleClear,
    filterValues,
    handleCheckBox,

}
) {
    const ref = useRef();
    const location = useLocation()
    const dispatch = useDispatch()

    const buttonRef = useRef(null);

    const dropdownRef = useRef(null)
    const [isOpen, setisOpen] = useState(false);


    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });


    return (
        <>
            <div className='relative' ref={ref}>
                <p htmlFor='countryCode' className='text-xs  font-semibold text-[#000] pb-1.5 '>{label}</p>
                
                <button ref={buttonRef} data-testid="monitor_list" onClick={() => { setisOpen(!isOpen) }} className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '} rounded-lg px-3.5 py-[12px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} disabled={disabled}>
                    <p id={id} className={`${(value === "" || value === undefined || value === true) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                </button>

                
                <ul className={`py-4 pr-1 pl-4 rounded-lg bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                    {options &&options.length >0 ?
                        <li>
                            <ul>
                                {<li className='xl:flex justify-between items-center p-2 pr-4'>
                                    <div className="relative checkbox custom-checkBoxBlue1">
                                        <input
                                            type="checkbox"
                                            id='select_all'
                                            data-testid="select_all"
                                            checked={filterValues?.monitor_list?.length === options?.length}
                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                            className='prevent-click'
                                        />
                                        <label
                                            htmlFor='select_all'
                                            className={`text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4`}
                                        >Select All</label>
                                    </div>
                                    {options && options.length > 0 && (
                                        <button
                                            onClick={() => handleClear()}
                                            type='button'
                                            className={`text-xs font-semibold text-[#008586] ${(filterValues?.monitor_list?.length >0 ? 'ml-auto': 'hidden')}`}
                                        >
                                            Clear All
                                        </button>
                                    )}

                                </li>}
                            </ul>
                            <ul>
                                <li>
                                    <ul className={`max-h-[100px] overflow-auto scrollbar_gray pr-3`}>
                                        {
                                            options &&options?.map((item, idx) => (
                                                <li key={idx} className='flex justify-between items-center p-2'>
                                                    <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            id={item.monitorUserData.user_id}
                                                            data-testid={data_testid}
                                                            onChange={() => handleReadingTypeSelect(item.monitorUserData.user_id)}
                                                            checked={filterValues?.monitor_list?.includes(item.monitorUserData.user_id)}
                                                     
                                                            className=' prevent-click'
                                                        />
                                                        <label
                                                            title={item?.user_id + "-" + item?.user_name}
                                                            htmlFor={item.monitorUserData.user_id}
                                                            className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"
                                                        >{item.monitorUserData?.first_name || ''} {item.monitorUserData?.last_name || ''} {item.monitorUserData.user_id}</label>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        :
                        <p className="mt-2 text-center">No results found</p>
                    }
                </ul>
            </div>
        </>
    )
}
